import { ECreditApplicationStatus } from '@if/core/types'
import { MenuItem } from '@mui/material'
import { ECurrentCustomerStep } from '@src/types/Constants'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export function useCreditApplicationStatuses() {
  const { t } = useTranslation()

  return useMemo(
    () => [
      <MenuItem key={ECreditApplicationStatusFilters.All} value={ECreditApplicationStatusFilters.All}>
        {t('common.all')}
      </MenuItem>,
      <MenuItem key={ECreditApplicationStatusFilters.Active} value={ECreditApplicationStatusFilters.Active}>
        {t('creditApplicationStatus.active')}
      </MenuItem>,
      <MenuItem key={ECreditApplicationStatusFilters.Cancelled} value={ECreditApplicationStatusFilters.Cancelled}>
        {t('creditApplicationStatus.cancelled')}
      </MenuItem>,
      <MenuItem key={ECreditApplicationStatusFilters.Completed} value={ECreditApplicationStatusFilters.Completed}>
        {t('creditApplicationStatus.completed')}
      </MenuItem>,
      <MenuItem key={ECreditApplicationStatusFilters.Draft} value={ECreditApplicationStatusFilters.Draft}>
        {t('creditApplicationStatus.draft')}
      </MenuItem>,
      <MenuItem key={ECreditApplicationStatusFilters.Expired} value={ECreditApplicationStatusFilters.Expired}>
        {t('creditApplicationStatus.expired')}
      </MenuItem>,
    ],
    [t],
  )
}

export function useCurrentCustomerSteps() {
  const { t } = useTranslation()

  return useMemo(
    () => [
      <MenuItem key={ECurrentCustomerStep.Prequal} value={ECurrentCustomerStep.Prequal}>
        {t('dashboardEntriesStatus.prequal')}
      </MenuItem>,
      <MenuItem key={ECurrentCustomerStep.Credit} value={ECurrentCustomerStep.Credit}>
        {t('dashboardEntriesStatus.credit')}
      </MenuItem>,
      <MenuItem key={ECurrentCustomerStep.IncomeVerification} value={ECurrentCustomerStep.IncomeVerification}>
        {t('dashboardEntriesStatus.incomeVerification')}
      </MenuItem>,
      <MenuItem key={ECurrentCustomerStep.Contract} value={ECurrentCustomerStep.Contract}>
        {t('dashboardEntriesStatus.contract')}
      </MenuItem>,
      <MenuItem key={ECurrentCustomerStep.Funding} value={ECurrentCustomerStep.Funding}>
        {t('dashboardEntriesStatus.funding')}
      </MenuItem>,
    ],
    [t],
  )
}

export enum ECreditApplicationStatusFilters {
  Active = ECreditApplicationStatus.Active,
  Cancelled = ECreditApplicationStatus.Cancelled,
  Completed = ECreditApplicationStatus.Completed,
  Draft = ECreditApplicationStatus.Draft,
  Expired = ECreditApplicationStatus.Expired,
  All = 'all',
}
